export default __webpack_public_path__ + "static/media/H1005.3.f86af10b.mp3";